/**
 * Versão da autorização efetiva (cabeçalho X-Astral-Authz-Version).
 *
 * O backend envia, em toda resposta autenticada, uma impressão digital do
 * acesso efetivo do usuário. A interface guarda a versão que carregou em
 * /permissions/me; se uma resposta trouxer outra (permissão concedida ou
 * revogada na Central, contrato da empresa, catálogo…), dispara
 * "astral:authorization-changed": o AuthContext recarrega as permissões, o
 * CatalogContext o menu e useCapabilities as capacidades — sem novo login e
 * sem polling (qualquer requisição revela a mudança).
 *
 * Estado fora do React: o interceptor do axios não tem acesso aos contexts.
 */

export const AUTHZ_VERSION_HEADER = "x-astral-authz-version";
export const AUTHORIZATION_CHANGED_EVENT = "astral:authorization-changed";

let known = null;
let announced = null;

/** Versão carregada pela interface (resposta de /permissions/me). */
export function setKnownAuthzVersion(version) {
  known = version || null;
  announced = null;
}

export function knownAuthzVersion() {
  return known;
}

/**
 * Versão vista numa resposta. Anuncia a mudança uma vez por versão nova;
 * antes da primeira carga (known = null) não há com o que comparar.
 */
export function observeAuthzVersion(version, dispatch = defaultDispatch) {
  if (!version || !known || version === known || version === announced) {
    return false;
  }
  announced = version;
  dispatch(version);
  return true;
}

function defaultDispatch(version) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(AUTHORIZATION_CHANGED_EVENT, { detail: { version, source: "authz-version" } }),
    );
  }
}

/** Lê o cabeçalho de uma resposta do axios (AxiosHeaders ou objeto simples). */
export function authzVersionFromHeaders(headers) {
  if (!headers) return null;
  if (typeof headers.get === "function") {
    return headers.get(AUTHZ_VERSION_HEADER) || null;
  }
  return headers[AUTHZ_VERSION_HEADER] || null;
}
